import classNames from "classnames";
import React from "react";
import { InputTextArea } from "../common/input/InputTexArea";
import { InputTextBox } from "../common/input/InputTextBox";

export const CareCommentEdit = React.memo(function CareCommentEdit(props: CareCommentEditProps) {
    const {
        title,
        handleTitle,
        titleError,
        content,
        handleContent,
        contentError,
        show
    } = props;

    const inputAreaClassNames = classNames("input_area", { "show": show });

    return (
        <div className={inputAreaClassNames}>
            <div className={"error"}>{titleError}</div>
            <InputTextBox value={title} handleTextChanged={handleTitle} placeholder="タイトル" />
            <div className={"error"}>{contentError}</div>
            <InputTextArea value={content} handleTextChanged={handleContent} placeholder="内容" />
        </div>
    );
});

type CareCommentEditProps = {
    title: string,
    handleTitle: (value: string) => void,
    titleError: string,
    content: string,
    handleContent: (value: string) => void,
    contentError: string,
    show: boolean
}
